import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './ui/Icon';
import './VoiceAssistantTrigger.css';

interface VoiceAssistantTriggerProps {
  onClick: () => void;
  isRecording?: boolean;
}

const VoiceAssistantTrigger: React.FC<VoiceAssistantTriggerProps> = ({ onClick, isRecording = false }) => {
  const { t } = useTranslation();
  const label = isRecording
    ? t('voice.modal.stopRecording', 'Stop recording')
    : t('voice.modal.activateMic', 'Activate microphone');

  return (
    <div className="voice-assistant-trigger">
      <button
        type="button"
        onClick={onClick}
        className={`voice-trigger-button ${isRecording ? 'recording' : ''}`}
        title={label}
        aria-label={label}
        aria-pressed={isRecording}
      >
        {isRecording ? (
          <Icon name="mic-stop" size={28} className="icon-mic-stop" />
        ) : (
          <Icon name="mic" size={28} className="icon-mic" />
        )}
      </button>
    </div>
  );
};

export default VoiceAssistantTrigger;
